var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("div", { staticClass: "row justify-content-end" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c("div", { staticClass: "btn btn-group btn-group" }, [
                _vm.isTransporter || _vm.isAdmin || _vm.isLocalAdmin
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.bulkPodUpload",
                            modifiers: { bulkPodUpload: true }
                          },
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "btn btn-dark",
                        attrs: { title: "Bulk Upload POD" }
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "float-right fa fa-upload",
                            staticStyle: { cursor: "pointer" }
                          },
                          [_vm._v(" ")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isTransporter || _vm.isAdmin || _vm.isLocalAdmin
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.bulkDeliveryStatus",
                            modifiers: { bulkDeliveryStatus: true }
                          },
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "btn btn-success",
                        attrs: { title: "Bulk Update ADD" }
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "float-right fa fa-truck",
                            staticStyle: { cursor: "pointer" }
                          },
                          [_vm._v(" ")]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isTransporter
                  ? _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.bulkFileDownload",
                            modifiers: { bulkFileDownload: true }
                          },
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true }
                          }
                        ],
                        staticClass: "btn btn-primary",
                        attrs: { title: "Bulk Download POD" }
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "float-right fa fa-download",
                            staticStyle: { cursor: "pointer" }
                          },
                          [_vm._v(" ")]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c("b-card", { staticStyle: { "background-color": "#F9F9F9" } }, [
            _c("form", [
              _c("div", { staticClass: "form-row" }, [
                _c(
                  "div",
                  { staticClass: "form-group col-2" },
                  [
                    _c("label", [_vm._v("From Date")]),
                    _vm._v(" "),
                    _c("date-picker", {
                      attrs: { config: _vm.options },
                      model: {
                        value: _vm.s.fromDate,
                        callback: function($$v) {
                          _vm.$set(_vm.s, "fromDate", $$v)
                        },
                        expression: "s.fromDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group col-2" },
                  [
                    _c("label", [_vm._v("To Date")]),
                    _vm._v(" "),
                    _c("date-picker", {
                      attrs: { config: _vm.options },
                      model: {
                        value: _vm.s.toDate,
                        callback: function($$v) {
                          _vm.$set(_vm.s, "toDate", $$v)
                        },
                        expression: "s.toDate"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group col-2" },
                  [
                    _c("label", [_vm._v("Warehouse")]),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.locations,
                        label: "name",
                        multiple: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _vm._v(
                                "\n                " +
                                  _vm._s(option.name) +
                                  " – " +
                                  _vm._s(option.codes.join(",")) +
                                  "\n              "
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.s.location,
                        callback: function($$v) {
                          _vm.$set(_vm.s, "location", $$v)
                        },
                        expression: "s.location"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isTransporter
                  ? _c(
                      "div",
                      { staticClass: "form-group col-2" },
                      [
                        _c("label", [_vm._v("Transporter")]),
                        _vm._v(" "),
                        _c("v-select", {
                          attrs: {
                            options: _vm.transporters,
                            label: "name",
                            multiple: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(option.name.substring(0, 10)) +
                                        "\n              "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            992183605
                          ),
                          model: {
                            value: _vm.s.transporter,
                            callback: function($$v) {
                              _vm.$set(_vm.s, "transporter", $$v)
                            },
                            expression: "s.transporter"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isTransporter && !_vm.isCustomer
                  ? _c(
                      "div",
                      { staticClass: "form-group col-3" },
                      [
                        _c("label", [_vm._v("Customer")]),
                        _vm._v(" "),
                        _c("v-select", {
                          attrs: {
                            options: _vm.customers,
                            label: "name",
                            multiple: ""
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "option",
                                fn: function(option) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(option.code) +
                                        " - " +
                                        _vm._s(option.name) +
                                        "\n              "
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            982557526
                          ),
                          model: {
                            value: _vm.s.customer,
                            callback: function($$v) {
                              _vm.$set(_vm.s, "customer", $$v)
                            },
                            expression: "s.customer"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-group col-1" }, [
                  _c("label", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  !_vm.podSearching
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: { click: _vm.getPOD }
                        },
                        [
                          _c("i", { staticClass: "fa fa-search" }),
                          _vm._v(" Search\n            ")
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.podSearching
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          attrs: { type: "button" },
                          on: { click: _vm.getPOD }
                        },
                        [
                          _c("i", { staticClass: "fa fa-search fa-spin" }),
                          _vm._v(" Searching\n            ")
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              ref: "filterEwbs",
              attrs: { id: "filterEwbs", title: "Filter Results", size: "lg" }
            },
            [
              _c("div", { staticClass: "form-row" }, [
                _c(
                  "div",
                  { staticClass: "form-group col-2" },
                  [
                    _c("label", [_vm._v("Divisions")]),
                    _vm._v(" "),
                    _c("v-select", {
                      attrs: {
                        options: _vm.divisions,
                        placeholder: "Division",
                        searchable: false,
                        label: "text",
                        multiple: ""
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _vm._v(
                                "\n              " +
                                  _vm._s(option.text) +
                                  "\n            "
                              )
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.f.divisions,
                        callback: function($$v) {
                          _vm.$set(_vm.f, "divisions", $$v)
                        },
                        expression: "f.divisions"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-2" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Invoice No" } },
                      [
                        _c("b-form-input", {
                          attrs: { type: "text", placeholder: "Invoice No" },
                          model: {
                            value: _vm.f.invoiceNo,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "invoiceNo", $$v)
                            },
                            expression: "f.invoiceNo"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-1" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "LR No" } },
                      [
                        _c("b-form-input", {
                          attrs: { type: "text", placeholder: "LR No" },
                          model: {
                            value: _vm.f.lrNo,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "lrNo", $$v)
                            },
                            expression: "f.lrNo"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Cancelled?" } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.cancelledOptions },
                          model: {
                            value: _vm.f.cancelled,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "cancelled", $$v)
                            },
                            expression: "f.cancelled"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "NPD?" } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.npdOptions },
                          model: {
                            value: _vm.f.npdShipment,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "npdShipment", $$v)
                            },
                            expression: "f.npdShipment"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Sale Types" } },
                      [
                        _c("b-form-tags", {
                          staticClass: "mb-2",
                          attrs: { "add-on-change": "", "no-outer-focus": "" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(ref) {
                                var tags = ref.tags
                                var inputAttrs = ref.inputAttrs
                                var inputHandlers = ref.inputHandlers
                                var disabled = ref.disabled
                                var removeTag = ref.removeTag
                                return [
                                  tags.length > 0
                                    ? _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "list-inline d-inline-block mb-2"
                                        },
                                        _vm._l(tags, function(tag) {
                                          return _c(
                                            "li",
                                            {
                                              key: tag,
                                              staticClass: "list-inline-item"
                                            },
                                            [
                                              _c(
                                                "b-form-tag",
                                                {
                                                  attrs: {
                                                    title: tag,
                                                    disabled: disabled,
                                                    variant: "info"
                                                  },
                                                  on: {
                                                    remove: function($event) {
                                                      return removeTag(tag)
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(tag) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-select",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            disabled:
                                              disabled ||
                                              _vm.availableOptions.length === 0,
                                            options: _vm.availableOptions
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "first",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "option",
                                                      {
                                                        attrs: {
                                                          disabled: "",
                                                          value: ""
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Choose a Sales Type..."
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        "b-form-select",
                                        inputAttrs,
                                        false
                                      ),
                                      inputHandlers
                                    )
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.f.saleTypes,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "saleTypes", $$v)
                            },
                            expression: "f.saleTypes"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Delivery Status" } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.deliveredOptions },
                          model: {
                            value: _vm.f.delivered,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "delivered", $$v)
                            },
                            expression: "f.delivered"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Shipment Status" } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.shipmentOptions },
                          model: {
                            value: _vm.f.shipped,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "shipped", $$v)
                            },
                            expression: "f.shipped"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "POD Health" } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.goodPODOptions },
                          model: {
                            value: _vm.f.goodPOD,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "goodPOD", $$v)
                            },
                            expression: "f.goodPOD"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "POD Status" } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.noPODOptions },
                          model: {
                            value: _vm.f.noPOD,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "noPOD", $$v)
                            },
                            expression: "f.noPOD"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "POD Verified Status?" } },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.podVerifiedStatus },
                          model: {
                            value: _vm.f.verified,
                            callback: function($$v) {
                              _vm.$set(_vm.f, "verified", $$v)
                            },
                            expression: "f.verified"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [_vm._v(" ")]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col text-right",
                  staticStyle: { "margin-top": "20px" }
                })
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "modal-footer" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "info" },
                      on: {
                        click: function($event) {
                          return _vm.filterPOD()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-filter" }),
                      _vm._v(" Filter Results\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "warning" },
                      on: {
                        click: function($event) {
                          return _vm.clear()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-times-circle" }),
                      _vm._v(" Clear\n        ")
                    ]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3 mb-3 justify-content-between" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "col" }, [
              _vm.makeFilters.length > 0
                ? _c(
                    "ul",
                    { staticClass: "list-group list-group-horizontal" },
                    [
                      _c(
                        "li",
                        {
                          staticClass:
                            "list-group-item list-group-item-info pr-3",
                          staticStyle: { padding: "5px" }
                        },
                        [_vm._v("Filters")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.makeFilters, function(f) {
                        return _c(
                          "li",
                          {
                            key: f.what,
                            staticClass: "list-group-item text-center",
                            staticStyle: { padding: "5px" }
                          },
                          [
                            _c("span", { staticClass: "pr-1" }, [
                              _vm._v(_vm._s(f.what))
                            ]),
                            _vm._v(" "),
                            f.val === "Yes"
                              ? _c("span", { staticClass: "text-success" }, [
                                  _c("i", { staticClass: "fa fa-check" })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            f.val === "No"
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _c("i", { staticClass: "fa fa-times" })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            f.val !== "No" && f.val !== "Yes"
                              ? _c("span", { staticClass: "text-info" }, [
                                  _vm._v(_vm._s(f.val))
                                ])
                              : _vm._e()
                          ]
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c("h6", { staticClass: "form-head mt-1" }, [
                _vm._v("Total Results – " + _vm._s(_vm.totalItems))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c(
                "form",
                {
                  attrs: {
                    method: "post",
                    action: _vm.csvDownloadUrl,
                    target: "_blank"
                  }
                },
                [
                  _c(
                    "b-button-group",
                    [
                      _c("input", {
                        attrs: { type: "hidden", name: "fromDate" },
                        domProps: { value: _vm.sFromDate }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "toDate" },
                        domProps: { value: _vm.sToDate }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "locations" },
                        domProps: { value: _vm.sLocations() }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "transporters" },
                        domProps: { value: _vm.sTransporters() }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "customers" },
                        domProps: { value: _vm.sCustomers() }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: "filter" },
                        domProps: { value: _vm.sFilter() }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "submit",
                            variant: "secondary",
                            size: "sm"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-download" }),
                          _vm._v(" Excel\n            ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.showFilter()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-filter" }),
                          _vm._v(" Filter\n            ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-sm table-responsive-sm table-bordered text-center fixed_headers"
                  },
                  [
                    _c("thead", { staticClass: "thead-light one" }, [
                      _c("tr", [
                        _c("th", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("th", [_vm._v(" ")]),
                        _vm._v(" "),
                        _c("th", { attrs: { colspan: "2" } }, [
                          _vm._v("Invoice")
                        ]),
                        _vm._v(" "),
                        _c("th", { attrs: { colspan: "1" } }, [
                          _vm._v("Shipped")
                        ]),
                        _vm._v(" "),
                        !_vm.isCustomer
                          ? _c("th", { attrs: { colspan: "2" } }, [
                              _vm._v("Customer")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("th", { attrs: { colspan: "2" } }, [
                          _vm._v("Forward")
                        ]),
                        _vm._v(" "),
                        _c("th", { attrs: { colspan: "1" } }, [
                          _vm._v("Actual")
                        ]),
                        _vm._v(" "),
                        _c("th", { attrs: { colspan: "1" } }, [
                          _vm._v("Estimated")
                        ]),
                        _vm._v(" "),
                        _c("th", { attrs: { colspan: "3" } }, [
                          _vm._v("Return")
                        ]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Number")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Actual Date")]),
                        _vm._v(" "),
                        !_vm.isTransporter
                          ? _c("th", { attrs: { colspan: "1" } }, [
                              _vm._v("Transporter")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isCustomer
                          ? _c("th", { attrs: { colspan: "2" } }, [_vm._v(" ")])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCustomer
                          ? _c("th", { attrs: { colspan: "1" } }, [_vm._v(" ")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("th", { attrs: { colspan: "1" } }, [
                          _vm._v("Actions")
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("thead", { staticClass: "thead-light two" }, [
                      _c("tr", [
                        _c("th", [_vm._v("DIV")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Warehouse")]),
                        _vm._v(" "),
                        _c("th", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.sortPOD("docNo")
                                }
                              }
                            },
                            [
                              _vm._v("\n                No\n                "),
                              _vm.sortBy === "docNo" && _vm.sort === "asc"
                                ? _c("i", { staticClass: "fa fa-angle-up" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortBy === "docNo" && _vm.sort === "desc"
                                ? _c("i", { staticClass: "fa fa-angle-down" })
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.sortPOD("docDt")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Date\n                "
                              ),
                              _vm.sortBy === "docDt" && _vm.sort === "asc"
                                ? _c("i", { staticClass: "fa fa-angle-up" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortBy === "docDt" && _vm.sort === "desc"
                                ? _c("i", { staticClass: "fa fa-angle-down" })
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.sortPOD("shippedValue")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                Value\n                "
                              ),
                              _vm.sortBy === "shippedValue" &&
                              _vm.sort === "asc"
                                ? _c("i", { staticClass: "fa fa-angle-up" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.sortBy === "shippedValue" &&
                              _vm.sort === "desc"
                                ? _c("i", { staticClass: "fa fa-angle-down" })
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        !_vm.isCustomer ? _c("th", [_vm._v("Code")]) : _vm._e(),
                        _vm._v(" "),
                        !_vm.isCustomer ? _c("th", [_vm._v("Name")]) : _vm._e(),
                        _vm._v(" "),
                        _c("th", [_vm._v("LR")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Date")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Ship Date")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Delivery Date")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("LR")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("CARE")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Date")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Of Pkg")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Of Delivery")]),
                        _vm._v(" "),
                        !_vm.isTransporter
                          ? _c("th", [_vm._v("Code")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("th", [_vm._v("Status")]),
                        _vm._v(" "),
                        !_vm.isCustomer
                          ? _c("th", [_vm._v("Comments")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("th", [
                          _c(
                            "form",
                            {
                              attrs: {
                                method: "post",
                                action: _vm.imageDownloadUrl,
                                target: "_blank"
                              }
                            },
                            [
                              _vm._l(_vm.downloadQueue, function(id) {
                                return _c("input", {
                                  key: id,
                                  attrs: { type: "hidden", name: "id" },
                                  domProps: { value: id }
                                })
                              }),
                              _vm._v(" "),
                              _vm.downloadQueue.length > 0
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "b-tooltip",
                                          rawName: "v-b-tooltip.hover",
                                          modifiers: { hover: true }
                                        }
                                      ],
                                      staticClass: "btn btn-sm btn-primary",
                                      attrs: {
                                        type: "submit",
                                        title: "Download All as ZIP"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.downloadBulk()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v("\n                  Download "),
                                      _c(
                                        "span",
                                        { staticClass: "badge badge-light" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.downloadQueue.length)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "sr-only" }, [
                                        _vm._v("unread messages")
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.filteredPod, function(p) {
                        return _c(
                          "tr",
                          {
                            key: p.id,
                            class: {
                              "text-muted": p.returnLrNo || p.cancelled,
                              "text-secondary": p.goodPod !== null
                            }
                          },
                          [
                            _c("td", [_vm._v(_vm._s(p.newDivisionD))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(p.locationCode))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(p.docNo))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", { staticClass: "one-line-text" }, [
                                _vm._v(_vm._s(_vm._f("date")(p.docDt)))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm._f("toNumber")(p.shippedValue)))
                            ]),
                            _vm._v(" "),
                            !_vm.isCustomer
                              ? _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(p.customerCode) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isCustomer
                              ? _c("td", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "one-line-text hide-excess text-left"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(p.customerName) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("td", [
                              p.lrNo
                                ? _c("div", [
                                    p.transporter && p.transporter.trackingUrl
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: p.transporter.trackingUrl.replace(
                                                "%docket%",
                                                p.lrNo
                                              ),
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(p.lrNo) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    p.transporter && !p.transporter.trackingUrl
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(p.lrNo) +
                                              "\n                "
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", { staticClass: "one-line-text" }, [
                                _vm._v(_vm._s(_vm._f("date")(p.lrDt)))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm._f("date")(p.actualShipDate)))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  staticClass: "text-info font-italic",
                                  staticStyle: { "font-size": "xx-small" },
                                  attrs: { title: "Estimated Delivery Date" }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm._f("date")(p.estimatedADD)) +
                                      "\n              "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              p.returnLrNo
                                ? _c("div", [
                                    p.transporter && p.transporter.trackingUrl
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: p.transporter.trackingUrl.replace(
                                                "%docket%",
                                                p.lrNo
                                              ),
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(p.returnLrNo) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    p.transporter && !p.transporter.trackingUrl
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(p.returnLrNo) +
                                              "\n                "
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(p.grn))]),
                            _vm._v(" "),
                            _c("td", [
                              _c("span", { staticClass: "one-line-text" }, [
                                p.deliveryStatus === "RTO" ||
                                (p.returnLrNo !== null &&
                                  p.returnLrNo.trim().length > 0) ||
                                (p.grn !== null && p.grn.trim().length > 0)
                                  ? _c("span", { staticClass: "text-danger" }, [
                                      _c("i", { staticClass: "fa fa-undo" }),
                                      _vm._v(
                                        "  " +
                                          _vm._s(
                                            _vm._f("date")(p.actualDeliveryDate)
                                          ) +
                                          "\n                "
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(p.noOfPkg))]),
                            _vm._v(" "),
                            _c("td", [
                              p.deliveryStatus === "DELIVERED" &&
                              (p.returnLrNo === null ||
                                p.returnLrNo.trim().length === 0) &&
                              (p.grn === null || p.grn.trim().length === 0)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "text-success",
                                      staticStyle: { "font-size": "xx-small" },
                                      attrs: { title: "Actual Delivery Date" }
                                    },
                                    [
                                      _c("i", { staticClass: "fa fa-check" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("date")(p.actualDeliveryDate)
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            !_vm.isTransporter
                              ? _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(p.transporterCode) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-center" },
                              [
                                _c("p-o-d-status", {
                                  key: p.containsPOD,
                                  attrs: { docket: p }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isCustomer
                              ? _c("td", [
                                  _c(
                                    "ul",
                                    { staticClass: "list-unstyled" },
                                    _vm._l(p.comments, function(c) {
                                      return _c("li", { key: c }, [
                                        _vm._v(_vm._s(c))
                                      ])
                                    }),
                                    0
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("td", [
                              p.cancelled === false
                                ? _c(
                                    "div",
                                    { staticClass: "btn-group" },
                                    [
                                      (_vm.isTransporter ||
                                        _vm.isAdmin ||
                                        _vm.isLocalAdmin) &&
                                      p.containsPOD !== true
                                        ? _c(
                                            "b-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                },
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.podUpload",
                                                  modifiers: { podUpload: true }
                                                }
                                              ],
                                              attrs: {
                                                title: "Upload POD",
                                                variant: "primary",
                                                size: "xs"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.uploadPOD(p)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-upload"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      p.containsPOD === true
                                        ? _c(
                                            "b-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              attrs: {
                                                title: "View POD",
                                                variant: "info",
                                                size: "xs"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.showPOD(p)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-eye"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isCustomer
                                        ? _c(
                                            "b-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                },
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.commentView",
                                                  modifiers: {
                                                    commentView: true
                                                  }
                                                }
                                              ],
                                              attrs: {
                                                title: "Add/View Comments",
                                                variant: "secondary",
                                                size: "xs"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addComments(p)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-comments"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      p.containsPOD === true &&
                                      _vm.downloadQueue.indexOf(p.id) === -1
                                        ? _c(
                                            "b-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              attrs: {
                                                title: "Add To Download Queue",
                                                variant: "success",
                                                size: "xs"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.addToDownloadQueue(
                                                    p
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-download"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      p.containsPOD === true &&
                                      _vm.downloadQueue.indexOf(p.id) > -1
                                        ? _c(
                                            "b-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              attrs: {
                                                title:
                                                  "Remove From Download Queue",
                                                variant: "warning",
                                                size: "xs"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeFromDownloadQueue(
                                                    p
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-times"
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      (_vm.isAdmin || _vm.isLocalAdmin) &&
                                      !_vm.isCustomer &&
                                      !_vm.isTransporter
                                        ? _c(
                                            "b-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  modifiers: { hover: true }
                                                },
                                                {
                                                  name: "b-modal",
                                                  rawName:
                                                    "v-b-modal.podDelete",
                                                  modifiers: { podDelete: true }
                                                }
                                              ],
                                              attrs: {
                                                title:
                                                  "Delete Uploaded PODs/ADD",
                                                variant: "danger",
                                                size: "xs"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.podDelete(p)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-times"
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c("b-pagination", {
                  attrs: {
                    size: "md",
                    align: "center",
                    limit: 20,
                    "total-rows": _vm.totalItems,
                    "per-page": _vm.perPage
                  },
                  on: { change: _vm.changePage },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "podView",
          attrs: {
            id: "podView",
            title: "View POD",
            size: "lg",
            centered: "",
            lazy: "",
            "hide-footer": ""
          }
        },
        [
          _c("basic-docket", {
            attrs: { docket: _vm.selectedDocket, comments: _vm.podComments }
          }),
          _vm._v(" "),
          _c("h4", { staticClass: "form-head" }, [
            _vm._v("Uploaded Files "),
            _c("span", { staticClass: "badge badge-primary" }, [
              _vm._v(_vm._s(_vm.podFiles.length))
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.podFiles, function(pi) {
            return _c(
              "div",
              { key: pi.id, staticClass: "row justify-content-end" },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "pod_image", attrs: { id: "pod_image" } },
                    [
                      _c(
                        "iframe",
                        {
                          staticClass: "m-3",
                          staticStyle: { "box-shadow": "2px 3px 4px #aaa" },
                          attrs: {
                            src: _vm.viewPodLink(pi, false),
                            height: _vm.iframeHeight,
                            width: _vm.iframeWidth
                          }
                        },
                        [_c("loading")],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-auto mb-3",
                    staticStyle: { "align-self": "flex-end" }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-sm btn-primary",
                        attrs: {
                          href: _vm.viewPodLink(pi, true),
                          target: "_blank"
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-download" }),
                        _vm._v(" Download\n        ")
                      ]
                    )
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          !_vm.isCustomer
            ? _c("div", { staticClass: "row justify-content-start mt-5" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-12" },
                  [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Add a Comment" } },
                          [
                            _c("b-form-textarea", {
                              attrs: {
                                id: "textarea2x",
                                placeholder: "Add a Comment",
                                rows: 3,
                                "max-rows": 6
                              },
                              model: {
                                value: _vm.newComment,
                                callback: function($$v) {
                                  _vm.newComment = $$v
                                },
                                expression: "newComment"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-end mt-5" }, [
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                !_vm.isCustomer
                  ? _c(
                      "b-btn",
                      {
                        attrs: { size: "", variant: "info" },
                        on: { click: _vm.saveComment }
                      },
                      [
                        _c("i", { staticClass: "fa fa-save" }),
                        _vm._v(" Save Comment\n        ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isCustomer
                  ? _c(
                      "b-btn",
                      {
                        attrs: { size: "", variant: "primary" },
                        on: { click: _vm.verifiedPOD }
                      },
                      [
                        _c("i", { staticClass: "fas fa-check" }),
                        _vm._v(" Good POD\n        ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isCustomer
                  ? _c(
                      "b-btn",
                      {
                        attrs: { size: "", variant: "danger" },
                        on: { click: _vm.makeBadPOD }
                      },
                      [
                        _c("i", { staticClass: "fas fa-times-hexagon" }),
                        _vm._v(" Bad POD\n        ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    attrs: { size: "", variant: "warning" },
                    on: { click: _vm.hideModal }
                  },
                  [
                    _c("i", { staticClass: "fas fa-times" }),
                    _vm._v(" Close\n        ")
                  ]
                )
              ],
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "podUpload",
          attrs: {
            id: "podUpload",
            title: "Upload POD",
            size: "lg",
            centered: "",
            lazy: "",
            "hide-footer": ""
          }
        },
        [
          _c("basic-docket", {
            attrs: { docket: _vm.selectedDocket, comments: _vm.podComments }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "form-head" }, [_vm._v("POD Upload")]),
          _vm._v(" "),
          _c(
            "b-list-group",
            _vm._l(_vm.podFiles, function(c) {
              return _c("b-list-group-item", { key: c.id }, [
                _c(
                  "div",
                  { staticClass: "d-flex w-100 justify-content-between" },
                  [
                    _c("h5", { staticClass: "mb-1" }, [
                      c.uploadedBy
                        ? _c("span", [_vm._v(_vm._s(c.uploadedBy.userName))])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(_vm._s(_vm._f("datetime")(c.uploadedAt)))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "mb-1" }, [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v(_vm._s(c.fileName))
                  ])
                ]),
                _vm._v(" "),
                _c("small", { staticClass: "text-muted" }, [
                  _vm._v(_vm._s(c.comment))
                ])
              ])
            }),
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "b-form",
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "New File" } },
                      [
                        _c("b-form-file", {
                          attrs: {
                            accept: "image/*, application/pdf",
                            state: true,
                            placeholder: "Choose a file..."
                          },
                          on: { change: _vm.onFileChange },
                          model: {
                            value: _vm.podFile,
                            callback: function($$v) {
                              _vm.podFile = $$v
                            },
                            expression: "podFile"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "Good POD?" } },
                      [
                        _c(
                          "b-form-radio-group",
                          {
                            attrs: { id: "radios2", name: "radioSubComponent" },
                            model: {
                              value: _vm.goodPod,
                              callback: function($$v) {
                                _vm.goodPod = $$v
                              },
                              expression: "goodPod"
                            }
                          },
                          [
                            _c("b-form-radio", { attrs: { value: "true" } }, [
                              _vm._v("Good POD")
                            ]),
                            _vm._v(" "),
                            _c("b-form-radio", { attrs: { value: "false" } }, [
                              _vm._v("BAD POD")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      { attrs: { label: "Add a Comment" } },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "textarea2",
                            placeholder: "Enter a Comment",
                            required: _vm.goodPod === false
                          },
                          model: {
                            value: _vm.newComment,
                            callback: function($$v) {
                              _vm.newComment = $$v
                            },
                            expression: "newComment"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Shipment Status")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.deliveryStatus,
                              expression: "deliveryStatus"
                            }
                          ],
                          staticClass: "form-control",
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.deliveryStatus = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "DELIVERED" } }, [
                            _vm._v("Delivered")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "RTO" } }, [
                            _vm._v("Returned")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_vm._v("Delivery Date")]),
                        _vm._v(" "),
                        _c("date-picker", {
                          attrs: { config: _vm.options },
                          model: {
                            value: _vm.add,
                            callback: function($$v) {
                              _vm.add = $$v
                            },
                            expression: "add"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.previewType === "image" && _vm.previewUrl
              ? _c("div", { staticClass: "col" }, [
                  _c("h5", { staticClass: "form-head" }, [_vm._v("Preview")]),
                  _vm._v(" "),
                  _vm.previewUrl && _vm.previewType === "image"
                    ? _c("img", {
                        staticStyle: {
                          "max-height": "300px",
                          "max-width": "300px"
                        },
                        attrs: { src: _vm.previewUrl }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.previewUrl && _vm.previewType === "pdf"
                    ? _c("canvas", { attrs: { id: "the-canvas" } })
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-end mt-5" }, [
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _c(
                  "b-btn",
                  {
                    attrs: { size: "", variant: "primary" },
                    on: { click: _vm.savePOD }
                  },
                  [
                    _c("i", { staticClass: "fa fa-save" }),
                    _vm._v(" Save POD\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    attrs: { size: "", variant: "warning" },
                    on: { click: _vm.hideModal }
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Close\n        ")
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "podDelete",
          attrs: {
            id: "podDelete",
            title: "Delete POD/ADD or Both",
            size: "lg",
            centered: "",
            lazy: "",
            "hide-footer": ""
          }
        },
        [
          _c("basic-docket", {
            attrs: { docket: _vm.selectedDocket, comments: _vm.podComments }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "form-head" }, [_vm._v("Delete POD/ADD")]),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { size: "md", label: "What to Delete?" } },
            [
              _c(
                "b-form-radio",
                {
                  attrs: {
                    disabled:
                      _vm.selectedDocket &&
                      _vm.selectedDocket.containsPOD !== true,
                    value: "pod"
                  },
                  model: {
                    value: _vm.deleteSelected,
                    callback: function($$v) {
                      _vm.deleteSelected = $$v
                    },
                    expression: "deleteSelected"
                  }
                },
                [_vm._v("Delete POD\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-form-radio",
                {
                  attrs: { value: "add" },
                  model: {
                    value: _vm.deleteSelected,
                    callback: function($$v) {
                      _vm.deleteSelected = $$v
                    },
                    expression: "deleteSelected"
                  }
                },
                [_vm._v("Delete ADD")]
              ),
              _vm._v(" "),
              _c(
                "b-form-radio",
                {
                  attrs: {
                    disabled:
                      _vm.selectedDocket &&
                      _vm.selectedDocket.containsPOD !== true,
                    value: "both"
                  },
                  model: {
                    value: _vm.deleteSelected,
                    callback: function($$v) {
                      _vm.deleteSelected = $$v
                    },
                    expression: "deleteSelected"
                  }
                },
                [_vm._v("Delete POD and ADD\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-end mt-5" }, [
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _c(
                  "b-btn",
                  {
                    attrs: { size: "", variant: "primary" },
                    on: { click: _vm.deletePOD }
                  },
                  [
                    _c("i", { staticClass: "fa fa-save" }),
                    _vm._v(" Delete\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    attrs: { size: "", variant: "warning" },
                    on: { click: _vm.hideModal }
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Close\n        ")
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "bulkPodUpload",
          attrs: {
            id: "bulkPodUpload",
            title: "Upload POD",
            size: "lg",
            centered: "",
            lazy: "",
            "hide-footer": ""
          }
        },
        [
          _c("h4", { staticClass: "form-head" }, [_vm._v("Bulk POD Upload")]),
          _vm._v(" "),
          _c(
            "b-form",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Select PODs" } },
                [
                  _c("b-form-file", {
                    ref: "podFilesInput",
                    attrs: {
                      plain: "",
                      multiple: "",
                      accept:
                        "image/jpeg, image/png, image/gif, application/pdf",
                      placeholder: "Choose files ..."
                    },
                    on: {
                      change: function($event) {
                        return _vm.filesSelected()
                      }
                    },
                    model: {
                      value: _vm.podFiles,
                      callback: function($$v) {
                        _vm.podFiles = $$v
                      },
                      expression: "podFiles"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "table",
                {
                  staticClass: "table mt-3 table-sm",
                  staticStyle: { "font-size": "medium" },
                  attrs: { id: "bulkPodTable" }
                },
                [
                  _c("thead", { staticClass: "thead-dark" }, [
                    _c("tr", [
                      _c("th", [_vm._v("File")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Document Type")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("LR/Invoice No")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Good POD?")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Delivery Date (YYYY-MM-DD)")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Shipment Status")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Comment")]),
                      _vm._v(" "),
                      _c("th", [_vm._v(" ")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.bulkPods, function(f) {
                      return _c("tr", { key: f.idx }, [
                        _c("td", [_vm._v(_vm._s(f.name))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("b-form-select", {
                              attrs: { options: _vm.docTypeOptions },
                              on: {
                                change: function($event) {
                                  return _vm.fetchADD(f)
                                },
                                blur: function($event) {
                                  return _vm.fetchADD(f)
                                }
                              },
                              model: {
                                value: f.docType,
                                callback: function($$v) {
                                  _vm.$set(f, "docType", $$v)
                                },
                                expression: "f.docType"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("b-form-input", {
                              attrs: { type: "text" },
                              on: {
                                change: function($event) {
                                  return _vm.fetchADD(f)
                                },
                                blur: function($event) {
                                  return _vm.fetchADD(f)
                                }
                              },
                              model: {
                                value: f.lrNo,
                                callback: function($$v) {
                                  _vm.$set(f, "lrNo", $$v)
                                },
                                expression: "f.lrNo"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c(
                              "b-form-radio-group",
                              {
                                attrs: { required: false },
                                model: {
                                  value: f.goodPod,
                                  callback: function($$v) {
                                    _vm.$set(f, "goodPod", $$v)
                                  },
                                  expression: "f.goodPod"
                                }
                              },
                              [
                                _c(
                                  "b-form-radio",
                                  { attrs: { value: "true" } },
                                  [_vm._v("Good POD")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-form-radio",
                                  { attrs: { value: "false" } },
                                  [_vm._v("BAD POD")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: f.add,
                                expression: "f.add"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: f.add },
                            on: {
                              click: function($event) {
                                return _vm.setDatePickerVisible(f.idx)
                              },
                              focus: function($event) {
                                return _vm.setDatePickerVisible(f.idx)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(f, "add", $event.target.value)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.showDatePicker(f.idx)
                            ? _c(
                                "div",
                                { staticClass: "dp-holder" },
                                [
                                  _c("date-picker", {
                                    attrs: { config: _vm.inlineOptions },
                                    on: {
                                      "dp-change": function($event) {
                                        return _vm.setDatePickerVisible(-1)
                                      },
                                      change: function($event) {
                                        return _vm.setDatePickerVisible(-1)
                                      }
                                    },
                                    model: {
                                      value: f.add,
                                      callback: function($$v) {
                                        _vm.$set(f, "add", $$v)
                                      },
                                      expression: "f.add"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: f.deliveryStatus,
                                  expression: "f.deliveryStatus"
                                }
                              ],
                              staticClass: "form-control",
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    f,
                                    "deliveryStatus",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "DELIVERED" } }, [
                                _vm._v("Delivered")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "RTO" } }, [
                                _vm._v("Returned")
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Enter a Comment",
                                required: f.goodPod === false
                              },
                              model: {
                                value: f.comment,
                                callback: function($$v) {
                                  _vm.$set(f, "comment", $$v)
                                },
                                expression: "f.comment"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", { class: "text-" + f.status }, [
                            f.status === "danger"
                              ? _c("i", { staticClass: "fa fa-times-circle" })
                              : _vm._e(),
                            _vm._v(" "),
                            f.status === "info"
                              ? _c("i", { staticClass: "fa fa-exclamation" })
                              : _vm._e(),
                            _vm._v(" "),
                            f.status === "success"
                              ? _c("i", { staticClass: "fa fa-check" })
                              : _vm._e(),
                            _vm._v(" "),
                            f.status === "warning"
                              ? _c("i", {
                                  staticClass: "fa fa-exclamation-circle"
                                })
                              : _vm._e(),
                            _vm._v(
                              "\n                 " +
                                _vm._s(f.errMsg) +
                                "\n              "
                            )
                          ])
                        ])
                      ])
                    }),
                    0
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.savingBulkPOD
            ? _c(
                "div",
                { staticClass: "row justify-content-center m-5" },
                [_c("loading")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.savingBulkPOD
            ? _c("div", { staticClass: "row justify-content-end mt-5" }, [
                _c(
                  "div",
                  { staticClass: "col-auto" },
                  [
                    _vm.sizeValidated == true &&
                    !_vm.bulkValidated &&
                    _vm.bulkPods.length > 0
                      ? _c(
                          "b-btn",
                          {
                            attrs: { size: "", variant: "primary" },
                            on: { click: _vm.validatePods }
                          },
                          [
                            _c("i", { staticClass: "fa fa-save" }),
                            _vm._v(" Validate PODs\n        ")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.bulkValidated
                      ? _c(
                          "b-btn",
                          {
                            attrs: { size: "", variant: "success" },
                            on: { click: _vm.savePODs }
                          },
                          [
                            _c("i", { staticClass: "fa fa-save" }),
                            _vm._v(" Save PODs\n        ")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-btn",
                      {
                        attrs: { size: "", variant: "warning" },
                        on: { click: _vm.hideModal }
                      },
                      [
                        _c("i", { staticClass: "fa fa-times" }),
                        _vm._v(" Close\n        ")
                      ]
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "commentView",
          attrs: {
            id: "commentView",
            title: "Comments",
            size: "lg",
            centered: "",
            lazy: "",
            "hide-footer": ""
          }
        },
        [
          _c("basic-docket", {
            attrs: { docket: _vm.selectedDocket, comments: _vm.podComments }
          }),
          _vm._v(" "),
          _c(
            "b-form",
            [
              _c(
                "b-form-group",
                { attrs: { label: "New Comment" } },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      id: "textarea1",
                      placeholder: "Enter a Comment",
                      rows: 3,
                      "max-rows": 6
                    },
                    model: {
                      value: _vm.newComment,
                      callback: function($$v) {
                        _vm.newComment = $$v
                      },
                      expression: "newComment"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-end mt-5" }, [
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _c(
                  "b-btn",
                  {
                    attrs: { size: "", variant: "primary" },
                    on: { click: _vm.saveComment }
                  },
                  [
                    _c("i", { staticClass: "fa fa-save" }),
                    _vm._v(" Save Comment\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    attrs: { size: "", variant: "warning" },
                    on: { click: _vm.hideModal }
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Close\n        ")
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "bulkFileDownload",
          attrs: {
            id: "bulkFileDownload",
            title: "Bulk Download PODs",
            size: "lg",
            centered: "",
            lazy: "",
            "hide-footer": ""
          }
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Select Excel File (XLS)" } },
            [
              _c("b-form-file", {
                ref: "podFilesInput",
                attrs: {
                  plain: "",
                  accept: ".xls",
                  placeholder: "Choose file ..."
                },
                on: {
                  input: function($event) {
                    return _vm.bulkPODFileSelected()
                  }
                },
                model: {
                  value: _vm.bulkPODFile,
                  callback: function($$v) {
                    _vm.bulkPODFile = $$v
                  },
                  expression: "bulkPODFile"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.bulkPODError
            ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                _c("i", { staticClass: "fa fa-exclamation-circle" }),
                _vm._v("\n      " + _vm._s(_vm.bulkPODError) + "\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.bulkPODUploading
            ? _c(
                "div",
                { staticClass: "row justify-content-center m-5" },
                [_c("loading")],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.bulkPODList.length > 0
            ? _c("table", { staticClass: "table mt-3 table-borderless" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        "\n          Click Download Links One by One, in one batch 100 PODs will be available as zip File\n        "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.bulkPODList, function(idx, index) {
                    return _c("tr", { key: idx }, [
                      _c("td", [
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-outline-info",
                            attrs: {
                              href: "/inpod/misc/bulk-download?id=" + idx,
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              "Download Part - " +
                                _vm._s(index + 1) +
                                " Zip File"
                            )
                          ]
                        )
                      ])
                    ])
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-end mt-5" }, [
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-info",
                    attrs: { href: _vm.samplePODDownloadExcelLink }
                  },
                  [
                    _c("i", { staticClass: "fa fa-download" }),
                    _vm._v(" Excel Template\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    attrs: { variant: "warning" },
                    on: { click: _vm.hideModal }
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Close\n        ")
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "bulkDeliveryStatus",
          attrs: {
            id: "bulkDeliveryStatus",
            title: "Update Delivery Status in Bulk",
            size: "lg",
            centered: "",
            lazy: "",
            "hide-footer": ""
          }
        },
        [
          _c(
            "b-form",
            [
              _c("b-alert", { attrs: { variant: "info", show: "" } }, [
                _c("i", { staticClass: "fa fa-exclamation-circle" }),
                _vm._v(
                  " Excel Template Has Changed, Kindly\n        Download New Excel\n      "
                )
              ]),
              _vm._v(" "),
              _vm.deliveryStatusError
                ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _c("i", { staticClass: "fa fa-exclamation-circle" }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.deliveryStatusError) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-group",
                { attrs: { label: "Select Excel File (XLS)" } },
                [
                  _c("b-form-file", {
                    ref: "podFilesInput",
                    attrs: {
                      plain: "",
                      accept: ".xls",
                      placeholder: "Choose file ..."
                    },
                    on: {
                      input: function($event) {
                        return _vm.deliveryStatusFileSelected()
                      }
                    },
                    model: {
                      value: _vm.deliveryStatusFile,
                      callback: function($$v) {
                        _vm.deliveryStatusFile = $$v
                      },
                      expression: "deliveryStatusFile"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.deliveryStatusUploading
                ? _c(
                    "div",
                    { staticClass: "row justify-content-center m-5" },
                    [_c("loading")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.deliveryUpdatedList.length > 0
                ? _c("table", { staticClass: "table mt-3" }, [
                    _c("thead", { staticClass: "thead-dark" }, [
                      _c("tr", [
                        _c("th", [_vm._v("Document Type")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("LR/Invoice No")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Delivery Date (YYYY-MM-DD)")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Shipment Status")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Status")])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.deliveryUpdatedList, function(ds) {
                        return _c("tr", { key: ds.lrNo }, [
                          _c("td", [_vm._v(_vm._s(ds.docType))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(ds.lrNo))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(ds.delDt))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(ds.delSt))]),
                          _vm._v(" "),
                          _c("td", [
                            !ds.ok
                              ? _c("span", { staticClass: "text-danger" }, [
                                  _vm._v(_vm._s(ds.err))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            ds.ok
                              ? _c("span", { staticClass: "text-success" }, [
                                  _vm._v("Updated")
                                ])
                              : _vm._e()
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row justify-content-end mt-5" }, [
            _c(
              "div",
              { staticClass: "col-auto" },
              [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-info",
                    attrs: { href: _vm.sampleDeliveryStatusExcelLink }
                  },
                  [
                    _c("i", { staticClass: "fa fa-download" }),
                    _vm._v(" Excel Template\n        ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    attrs: { variant: "warning" },
                    on: { click: _vm.hideModal }
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" Close\n        ")
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("h4", { staticClass: "form-head" }, [_vm._v("POD Management")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto mr-5" }, [
      _c("h4", { staticClass: "form-head" }, [_vm._v("Results")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-259c930a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-259c930a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PODManage.vue
// module id = null
// module chunks = 